export default class Clue{
    constructor(id, title, sentence, level){
        this.id = id;
        this.title = title;
        this.sentence = sentence;
        this.level = level;
    }
}